import { MessageCircle, Check, Star, Sparkles } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/site/Reveal";
import { Eyebrow } from "@/components/site/ui";
import { PACKAGES, CONTACT, EKTIREN, waLink } from "@/data/site";

export default function Paketler() {
  return (
    <div className="pt-4">
      <section className="relative py-20 sm:py-24 overflow-hidden grain">
        <div className="absolute top-10 right-10 w-[400px] h-[400px] bg-neon-magenta/20 blur-[130px] rounded-full" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 text-center">
          <Eyebrow className="justify-center">Paketler &amp; Fiyatlar</Eyebrow>
          <h1 className="mt-6 font-display font-extrabold text-5xl sm:text-7xl leading-[0.95]">
            <MaskedLines className="inline-block" lines={["Sosyal Medya"]} />
            <span className="block text-gradient">Yönetim Paketleri</span>
          </h1>
          <Reveal delay={0.4}>
            <div className="mt-6 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-neon-magenta/15 border border-neon-magenta/30 text-sm font-semibold text-neon-pink">
              <Sparkles className="w-4 h-4" /> Kampanya ay sonuna kadar geçerli!
            </div>
          </Reveal>
        </div>
      </section>

      {/* Pricing */}
      <section className="pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-3 gap-6 items-stretch">
          {PACKAGES.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.1}>
              <div
                data-testid={`paket-card-${p.id}`}
                className={`relative h-full flex flex-col rounded-3xl p-8 border transition-transform hover:-translate-y-1 ${
                  p.highlight ? "neon-border glass-strong glow-magenta" : "bg-ink-700 border-white/10"
                }`}
              >
                {p.highlight && (
                  <span className="absolute -top-3 left-1/2 -translate-x-1/2 inline-flex items-center gap-1 px-4 py-1 rounded-full bg-gradient-to-r from-cobalt to-neon-magenta text-white text-xs font-bold whitespace-nowrap">
                    <Star className="w-3 h-3 fill-white" /> EN POPÜLER
                  </span>
                )}
                <div className="font-mono text-xs uppercase tracking-widest text-cobalt-300">{p.subtitle}</div>
                <h2 className="mt-2 font-display text-3xl font-extrabold">{p.name}</h2>
                <div className="mt-5 flex items-end gap-2">
                  <span className="text-slate-500 line-through text-lg">{p.oldPrice}₺</span>
                  <span className="font-display text-5xl font-extrabold text-gradient">{p.price}₺</span>
                </div>
                <span className="text-slate-400 text-sm">aylık · KDV hariç</span>

                <div className="my-6 h-px bg-white/10" />
                <ul className="space-y-3 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className="flex gap-2.5 text-sm text-slate-300">
                      <Check className="w-4 h-4 text-neon-pink shrink-0 mt-0.5" /> {f}
                    </li>
                  ))}
                </ul>
                <a
                  href={waLink(CONTACT.phoneRaw, `Merhaba, ${p.name} paketini (${p.price}₺/ay) sipariş etmek istiyorum.`)}
                  target="_blank" rel="noreferrer"
                  data-testid={`paket-cta-${p.id}`}
                  className={`mt-8 inline-flex items-center justify-center gap-2 px-6 py-4 rounded-full font-semibold transition-transform hover:scale-[1.03] ${
                    p.highlight ? "bg-gradient-to-r from-cobalt to-neon-magenta text-white" : "bg-white/10 text-white hover:bg-white/15"
                  }`}
                >
                  <MessageCircle className="w-4 h-4" /> {p.name} Paketini Al
                </a>
                <p className="mt-3 text-center text-[11px] font-mono text-slate-500">Dijital Altyapı: {EKTIREN.name}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      {/* Custom package */}
      <section className="pb-24">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <Reveal className="rounded-3xl bg-ink-700 border border-white/10 p-10 flex flex-col md:flex-row items-center gap-6 text-center md:text-left">
            <div className="flex-1">
              <h2 className="font-display text-3xl font-extrabold">Sana özel paket mi lazım?</h2>
              <p className="mt-3 text-slate-300">İşletmenin ihtiyaçlarına göre özel içerik, çekim ve reklam paketleri hazırlıyoruz. Hedeflerini konuşalım, en uygun teklifi çıkaralım.</p>
            </div>
            <a
              href={waLink(CONTACT.phoneRaw, "Merhaba, işletmeme özel bir sosyal medya paketi istiyorum.")}
              target="_blank" rel="noreferrer"
              data-testid="custom-package-cta"
              className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-gradient-to-r from-cobalt to-neon-purple text-white font-semibold text-lg shrink-0 hover:scale-[1.03] transition-transform"
            >
              <MessageCircle className="w-5 h-5" /> Özel Teklif Al
            </a>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
